<template>
  <div class="wrapper border-bottom white-bg page-heading">
		<div class="container">
			<div class="row">
				<div class="col-sm-8 col-lg-8">
          <heading-loading v-if="loading"></heading-loading>
					<h1 v-else><i class="far fa-file-invoice m-r-sm"></i> Invoice {{ decorated.xero_number }}</h1>
				</div>
				<div class="col-sm-4 col-lg-4" v-if="notLoading">
					<p v-if="!decorated.isPaid" class="invoice-due" >Due: {{ decorated.remaining }}</p>
					<p v-else class="invoice-due complete" >Paid</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { headingLoading } from 'mixins'

  export default {
    mixins: [headingLoading],

    computed: mapGetters('invoice', { decorated: 'invoiceDecorated' })
  }
</script>



// WEBPACK FOOTER //
// ShowHeading.vue?1f1e145e